import React from 'react';
import ContentPage from 'components/ContentPage';
import config from 'config';
import i18next from 'i18next';
import { SplitTextImageSection, HighlightedImageSection, TextSection } from 'components/ContentSections';
import { getAllLanguageSlugs, getLanguage } from 'lang';

const Charting = ({}) => {
  return (
    <ContentPage
      pageName={'charting'}
      title={'Medical Charting'}
      subTitle={
        'Accelerate clinical encounters with configurable templates, flexible charting options, and real-time patient information.'
      }
      backgroundImage={'/images/covers/charting_cover.png'}
      metaDescription={`Work smarter and drive better patient outcomes with Doxer.io cloud-based medical charting. Obtain a comprehensive overview of a patient’s full clinical summary with precisely what you want to see - medicines, ailments, labs, allergies, vitals, and more.`}
      metaPagePath={'solutions/charting'}
      useMeta={true}>
      <TextSection title={'Save time with cloud-based medical charting'}>
        {`Work smarter and drive better patient outcomes with Doxer.io cloud-based medical charting. Obtain a comprehensive overview of a patient’s full clinical summary with precisely what you want to see - medicines, ailments, labs, allergies, vitals, vaccinations, and more. 
        You can even chart patient and clinical data from disparate sources, creating a single longitudinal record that gives the healthcare team a complete picture of the patient’s health. 
        Get quick access to critical patient info anywhere on the chart. Doxer.io provides information in one single view based on user preference. This feature is available as a free option, and we also offer a scalable pricing model for any practice size.`}
      </TextSection>

      <HighlightedImageSection
        title={'Enjoy flexible, secure, and efficient charting'}
        image={'/images/system/new_encounter.png'}
        imageAlt={'Doxer.io new encounter screen'}
        actionLink={`${config.appUrl}/register?utm_action_source=charting_highlighted_section`}
        actionText={i18next.t('index.header.action.try_for_free')}
        spacing={'slim'}
        textSplitSize={6}>
        {`Access pre-built medical charting templates and customize them to fit your workflow with our easy-to-use templates builder. Everything is drag and drop – no coding needed at all! Eliminate manual steps to avoid data entry errors and ensure quick charting. 
        With just a few clicks, Doxer.io allows you to dynamically populate patient data and templates in your medical notes.`}
      </HighlightedImageSection>

      <SplitTextImageSection
        title={'Empower easy data sharing and team collaboration'}
        image={'/images/illustrations/attached_file.svg'}
        imageAlt={'Attached file illustration'}
        textSide={'end'}
        zoom={false}>
        {`Seamless and secure medical charting ensures collaborative clinical decision-making based on shared information – across specialties and even outside the healthcare facility.
        You can coordinate patient care on an informed basis at any time and in any place. Easily share content and customizations from one user to another to ensure quick and easy onboarding so your practice does not miss any revenue.`}
      </SplitTextImageSection>
    </ContentPage>
  );
};

Charting.propTypes = {};

Charting.defaultProps = {};

export default Charting;
